var tw_callbacks_for_elements_added;
tw_callbacks_for_elements_added = [];

var tw_product_title;
tw_callbacks_for_elements_added['.shopify-section--main-product h1.product-info__title'] = function(tw_product_info_title) {
  tw_product_title = tw_product_info_title;
};

tw_callbacks_for_elements_added['.shopify-section--main-product ~ .shopify-section--apps #\\36 9179-text-3'] = function(tw_product_title_form_field) {
  if(tw_product_title) {
    tw_product_title_form_field.value = tw_product_title.textContent;
    tw_product_title_form_field.readOnly = true;
  }
};

tw_callbacks_for_elements_added['.bss-b2b-vat-input'] = function(tw_bss_b2b_vat_input) {
  var tw_bss_b2b_vat_validation_button = document.createElement('button');
  tw_bss_b2b_vat_validation_button.innerHTML = '<span>Valideren</span>';
  //tw_bss_b2b_vat_validation_button.style.display = 'none';
  tw_bss_b2b_vat_validation_button.classList.add('tw-bss-b2b-vat-validation-button');
  tw_bss_b2b_vat_validation_button.addEventListener('click', function(e) {
    e.preventDefault();
    var tw_bss_b2b_te_utils_cart_te_elements = BSS_B2B.te.utils.cart.teUtilsConcrete.loadTeElements();
    if (
      JSON.stringify(BSS_B2B.te.utils.cart.vatData)
      !==
      JSON.stringify({
        code: tw_bss_b2b_te_utils_cart_te_elements.input.value,
        type: parseInt(tw_bss_b2b_te_utils_cart_te_elements.select.value)
      })
    ) {
      tw_bss_b2b_te_utils_cart_te_elements.wrapper.setAttribute('show-message', 'TW_VAT_VALIDATING');
      BSS_B2B.utils.getCheckoutElements()[0].click();
    } else {
      // Button has been clicked twice for the same VAT number, do not click the checkout button
    }
  });
  tw_bss_b2b_vat_input.parentElement.appendChild(tw_bss_b2b_vat_validation_button);
};

tw_callbacks_for_elements_added['form[action*="/cart"] [name="checkout"]'] = function(tw_checkout_button) {
  tw_checkout_button.addEventListener('click', function(e) {
    var tw_bss_b2b_te_utils_cart_te_elements = BSS_B2B.te.utils.cart.teUtilsConcrete.loadTeElements();
    if (
      tw_bss_b2b_te_utils_cart_te_elements.input.value !== ''
      &&
      JSON.stringify(BSS_B2B.te.utils.cart.vatData)
      !==
      JSON.stringify({
        code: tw_bss_b2b_te_utils_cart_te_elements.input.value,
        type: parseInt(tw_bss_b2b_te_utils_cart_te_elements.select.value)
      })
    ) {
      tw_bss_b2b_te_utils_cart_te_elements.wrapper.setAttribute('show-message', 'TW_VAT_VALIDATING');
    }
  });
};

tw_callbacks_for_elements_added['#\31 56882-text-1'] = function(product_request_a_quote_form_product_name_field) {
  if(tw_product_title) {
    product_request_a_quote_form_product_name_field.value = tw_product_title.textContent;
    product_request_a_quote_form_product_name_field.classList.add('material_filled-input');
  }
};

/*function tw_stop_propagation_on_tmenu_item_link_texts(tmenu_item_link_text) {
  tmenu_item_link_text.onclick = function(e) {
    e.stopPropagation();
  };
}
tw_callbacks_for_elements_added['.tmenu_nav .tmenu_item .tmenu_item_link > .tmenu_item_text'] = tw_stop_propagation_on_tmenu_item_link_texts;
*/

function tw_callback_for_mutation_observer_for_new_elements_in_body(tw_mutations) {
  tw_mutations.forEach(function(tw_mutation) {
    tw_mutation.addedNodes.forEach(function(tw_added_node) {
      if(tw_added_node.nodeType === 1) {
        for(tw_element_match in tw_callbacks_for_elements_added) {
          if(tw_added_node.matches(tw_element_match)) {
            tw_callbacks_for_elements_added[tw_element_match](tw_added_node);
          } else {
            var tw_element_in_element = tw_added_node.querySelectorAll(tw_element_match).forEach(tw_callbacks_for_elements_added[tw_element_match]);
            if(tw_element_in_element) {
              tw_callbacks_for_elements_added[tw_element_match](tw_element_in_element);
            }
          }
        }
      }
    });
  });
}

window.addEventListener('DOMContentLoaded', function() {
  var tw_callback_selector, tw_callback_function;
  for(tw_callback_selector in tw_callbacks_for_elements_added) {
    tw_callback_function = tw_callbacks_for_elements_added[tw_callback_selector];
    document.querySelectorAll(tw_callback_selector).forEach(tw_callback_function);
  }
  
  var tw_mutation_observer_for_new_elements_in_body;
  tw_mutation_observer_for_new_elements_in_body = new MutationObserver(tw_callback_for_mutation_observer_for_new_elements_in_body);
  tw_mutation_observer_for_new_elements_in_body.observe(document.body, {childList: true, subtree: true});

  //document.querySelectorAll('.tmenu_nav .tmenu_item .tmenu_item_link > .tmenu_item_text').forEach(tw_stop_propagation_on_tmenu_item_link_texts);
});

/*var tw_product_title;
var tw_product_title_form_field;
window.addEventListener('DOMContentLoaded', function() {
  tw_product_title = document.querySelector('.shopify-section--main-product h1.product-info__title');
  if(tw_product_title) {
    tw_product_title_form_field = document.querySelector('.shopify-section--main-product ~ .shopify-section--apps #\\36 9179-text-3');
    if(tw_product_title_form_field) {
      
    }
  }
});*/